
/**
 * Compresses an image file to under 500KB.
 * Downscales to 1200px max dimension and converts to JPEG.
 */
export const compressImage = (file: File, maxFileSizeKB: number = 500): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target?.result as string;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                // Max resolution 1200px for cost/storage efficiency
                const MAX_DIM = 1200;
                if (width > height) {
                    if (width > MAX_DIM) {
                        height *= MAX_DIM / width;
                        width = MAX_DIM;
                    }
                } else {
                    if (height > MAX_DIM) {
                        width *= MAX_DIM / height;
                        height = MAX_DIM;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) return reject(new Error("Canvas context failed"));

                ctx.drawImage(img, 0, 0, width, height);

                // Start with 0.8 quality and reduce if still too large
                let quality = 0.8;
                let dataUrl = canvas.toDataURL('image/jpeg', quality);
                
                // Estimate size from base64 (roughly 0.75 ratio)
                let sizeInKB = (dataUrl.length * 0.75) / 1024;

                while (sizeInKB > maxFileSizeKB && quality > 0.1) {
                    quality -= 0.1;
                    dataUrl = canvas.toDataURL('image/jpeg', quality);
                    sizeInKB = (dataUrl.length * 0.75) / 1024;
                }

                resolve(dataUrl);
            };
        };
        reader.onerror = (error) => reject(error);
    });
};
